export const MOCK_CASE_NUMBERS = ["26M004381", "26M104381"] as const;

export type MockCaseNumber = (typeof MOCK_CASE_NUMBERS)[number];

